export default "__VITE_ASSET__e605476d__"